import ElementContent from '@/components/sections/builder/elements/header/header/content';
import ElementSetting from '@/components/sections/builder/elements/header/header/setting';
import { HeaderElementDataType } from '@/components/sections/builder/elements/header/header/type';
import { BetweenHorizonalStart } from 'lucide-react';

const defaultData: HeaderElementDataType = {
  name: 'Menu',
  stickyHeader: 'always',
  logoPosition: 'top-center',
  mobileLogoPosition: 'center',
  menuId: '',
  separator: true,
  padding: {
    top: 24,
    bottom: 24,
    left: 24,
    right: 24,
  },
  showSearch: true,
  megaMenuImageOverlay: false,
  searchBarPosition: 'modal',
};

export const ElementPreviewIcon = BetweenHorizonalStart;
const Header = {
  type: 'header',
  group: 'header',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  maxEntries: 1,
};

export default Header;
